import { adminAuthApi } from "./api";

// GET: 사용자 이름 가져오기
export const adminGetUserNameApi = (userId) => adminAuthApi.get(`/user/username/${userId}`)


// GET: 모든 사용자 리스트 가져오기
export const adminGetChatUserListApi = () => adminAuthApi.get(`/user/list/all`)
// export const adminGetChatUserList = () => adminAuthApi.get(`/chat/userlist`)